// Imports
import React from 'react';
import styled from 'styled-components';
import { Section, Div, H1, P } from '@reuse';
import { Row, Column } from 'react-foundation';
import { breakup } from '@break';

// Styles
const Jacket = styled(Section)`
    margin-top: 2rem;

    ${breakup.large`
        margin-top: 4rem;
    `}
`;

const Excerpt = styled(Div)`
    margin-top: 3.6rem;

    ${breakup.large`margin-top: 6rem;`}
`;

// Component
const Hero = ({title, excerpt}) => (
    <Jacket pad>
        <Row isExpanded>
            <Column small={12} medium={8} pushOnMedium={2}>
                <Div mpad>
                    <H1>{title}</H1>
                </Div>
            </Column>
        </Row>

        {
            // If an Excerpt is available, then show the excerpt
            excerpt &&
            <Row isExpanded>
                <Column small={12} medium={7} pushOnMedium={2}>
                    <Excerpt mpad>
                        <P>{excerpt}</P>
                    </Excerpt>
                </Column>
            </Row>
        }
    </Jacket>
);

export default Hero;